import React, { useState } from 'react';
import SideBarContainer from 'Containers/SideBarContainer';
import useTranslation from 'Hooks/useTranslation';
import Title from 'Components/Title';
import AchievementCard from 'Pages/Achievements/Components/AchievementCard/index';

import { AchievementContainer } from './style';
import useAchievements from './Hooks/useAchievements';

export default function MyAchievements() {
  const { achievements } = useAchievements();
  const { t2 } = useTranslation('Achievements');

  return (
    <SideBarContainer>
      <Title title={t2('title')} />
      <AchievementContainer>
        {achievements.map((achievement, index) => (
          <AchievementCard
            id={achievement.id}
            key={achievement.id}
            name={achievement.name}
            description={achievement.description}
          />
        ))}
      </AchievementContainer>
    </SideBarContainer>
  );
}
